import React, { useState } from "react";

interface PostcodeFormProps {
  postcode: string;
  setPostcode: (postcode: string) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const PostcodeForm: React.FunctionComponent<PostcodeFormProps> = ({
  postcode,
  setPostcode,
  handleSubmit,
}) => {
  const [postcodeError, setPostcodeError] = useState<string | null>(null);

  const validatePostcode = (postcode: string) => {
    const cleanPostcode = postcode.replace(/\s+/g, "");

    const postcodeRegexNoSpace = /^([A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}|GIR0AA)$/;

    if (!postcodeRegexNoSpace.test(cleanPostcode)) {
      return false;
    }

    if (cleanPostcode !== "GIR0AA") {
      const inward = cleanPostcode.slice(-3);
      const outward = cleanPostcode.slice(0, -3);
      return `${outward} ${inward}`;
    }

    return "GIR 0AA";
  };

  const handlePostcodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase();
    const validationResult = validatePostcode(value);

    if (validationResult) {
      setPostcode(validationResult);
      setPostcodeError(null);
    } else {
      setPostcode(value);
      setPostcodeError("Please enter a valid UK postcode.");
    }
  };

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (validatePostcode(postcode)) {
      handleSubmit(e);
    } else {
      setPostcodeError("Please enter a valid UK postcode.");
    }
  };

  return (
    <div className="px-4 pt-4">
      <div className="w-full">
        <p className="my-4 font-bold">Write to your MP on the EV policies that matter to you</p>
        <p className="my-4">
          Whether you're already driving electric or hoping to make the switch, you're the one navigating the reality of the EV transition - and policymakers need to hear from you.
        </p>
        <p className="my-4">
          From charging costs and proposed new taxes, to access to affordable EVs and support for the second-hand market, the issues are real and the decisions being made now will shape the future of electric driving for everyone.
        </p>
        <p className="my-4">
          Charge Up Change today. Write to your MP and call for practical EV policies that make switching easier, fairer and more accessible for everyone.
        </p>
        <p className="text-sm mb-2">Please answer all the questions below to generate an email.</p>
        <form className="mt-2" onSubmit={handleFormSubmit}>
          <div className="flex flex-row items-center gap-2">
            <input
              type="text"
              id="postcode"
              name="postcode"
              placeholder="Enter your postcode"
              className="border-2 rounded-md p-2 mt-1 w-full md:w-auto"
              value={postcode}
              onChange={handlePostcodeChange}
              required
            />
            <button
              type="submit"
              className="mt-1 bg-[#00b3bd] text-white font-bold py-2 px-4 rounded uppercase whitespace-nowrap"
            >
              Find your MP
            </button>
          </div>
          {postcodeError && (
            <p className="text-red-500 text-sm mt-1">{postcodeError}</p>
          )}
        </form>
      </div>
    </div>
  );
};

export default PostcodeForm;
